import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import infoList from "../../mixins/infoList";
import { getPayItemListWithPage } from "@/api/payItem";
import { syncCpConfig } from "@/api/data";
import PayOptions from "../../components/serverList/payOptions.vue";
import { getPayMap } from "@/utils/dictionary";
export default {
  components: {
    PayOptions: PayOptions
  },
  name: "gamePayConfig",
  mixins: [infoList],
  data: function data() {
    return {
      //分页
      listApi: getPayItemListWithPage,
      searchInfo: {
        pay_item_id: ""
      },
      payArray: []
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getPayMap();
            case 2:
              res = _context.sent;
              for (index in res) {
                _this.payArray.push({
                  pay_id: index,
                  pay_name: res[index]
                });
              }
              _this.queryEvent();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    queryEvent: function queryEvent() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getTableData();
            case 2:
              if (!_this2.tableData || _this2.tableData && _this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    openConfig: function openConfig() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return syncCpConfig({
                type: "c_pay_item"
              });
            case 2:
              res = _context3.sent;
              if (res.code === 0) {
                _this3.$message({
                  message: "同步cp配置成功",
                  type: "success"
                });
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    openPop: function openPop() {
      this.$notify({
        title: "充值项配置",
        dangerouslyUseHTMLString: true,
        message: "<div>(1)显示研发所有充值项Id、价格、名称。</div>" + "<div>(2)充值申请和审批需要使用对应的信息。</div>",
        duration: 0
      });
    }
  }
};